export default (text: string) => text.replace(/[^0-9A-Z-]/gi, "").toUpperCase();



// WEBPACK FOOTER //
// ./src/helpers/cleanup.ts